// Module
var code = `<div title="{{label}}" class="match-search-group-icon" data-toggle="tooltip"> <div class="{{'yellow-circle ' + circleClass}}"></div> </div> `;
// Exports
export default code;